module.exports = __webpack_public_path__ + "img/leaf_2.326ddc08.png";